import { get as getConstants } from '@lumapps/constants';

import { AppId } from '../constants';
import { Route } from '../types';
import { createUrl } from './createUrl';

const constants = getConstants();

/**
 * Convert a route into the `href` and `target` props of a link.
 * The target is `_self` for a react route opened from the legacy context, and `_blank` for an
 * external route.
 * @param route - route to convert.
 * @returns the props of the link.
 */
export const getRouteAsLinkProps = (route: Route) => {
    const href = createUrl(route);

    let target;

    if (route.appId !== AppId.legacy && constants.isLegacyContext) {
        target = '_self';
    } else if (route.appId === AppId.external) {
        target = '_blank';
    }

    return {
        href,
        target,
    };
};
